import React from 'react';
import { 
    Modal, 
} from 'components/lib';

const formFieldsOnboar_2 = {
    target1: {
      type: 'checkbox',
      options: ['Llegar a nuevos clientes'],
    },
    target2: {
      type: 'checkbox',
      options: ['Conocer mejor a mis clientes'],
    },
    target3: {
      type: 'checkbox',
      options: ['Fidelizar mis clientes'],
    },
    target4: {
      type: 'checkbox',
      options: ['Mejorar mi engagement'],
    },
    target5: {
      type: 'checkbox',
      options: ['Vender más'],
    },
}

export function Quiz2({ onboard, setOnboard, formData, btnShowAlert }){
    return (
        <Modal 
            logo={onboard}
            title={'¡Genial!'}
            subtitle={'Ahora definimos que objetivos buscas alcanzar'}
            text={'Aquí entenderemos de mejor manera para ayudarte a alcanzar tus metas'}
            form={formFieldsOnboar_2}
            next={true}
            type_form={onboard}
            onOnboard={setOnboard}
            onForm={formData}
            url={'/api/user/target'}
            method='PUT'
            btnShowAlert={btnShowAlert}
        />
    );
}